export const environment = {
    production: true,
    firebase: {
        apiKey: "AIzaSyCCJ4BVCuQA8aUZDimdCciqUhPMjqy3E_4",
        authDomain: "vetancid-es.firebaseapp.com",
        databaseURL: "https://vetancid-es.firebaseio.com",
        projectId: "vetancid-es",
        storageBucket: "vetancid-es.appspot.com",
        messagingSenderId: "840849458029",
        appId: "1:840849458029:web:0b60e7b0e3d8fdbb715064"
    }
};